module.exports = __webpack_public_path__ + "static/media/Group281.49023400.png";